import React, { useEffect, useState } from "react";
import Link from "./LocalizedLink";
import { useI18n } from "../i18n/I18nProvider";
import { api } from "../lib/api";

const DEFAULTS = {
  tagline: "The definitive guide to new luxury property in Finca Cortesín, Casares.",
  portal_text: "Independent property portal specializing in luxury homes and new developments in Finca Cortesín.",
  disclaimer: "Not affiliated with or endorsed by Finca Cortesín Resort.",
  contact_name: "Enova Estates",
  contact_address_line_1: "Manilva Beach Fase 2, Local 7",
  contact_address_line_2: "29692 Manilva, Málaga",
  contact_email: "bjorn@enovaestates.com",
  copyright: "© Enova Estates · livingfincacortesin.com",
  tagline_secondary: "Independent property advisory · Costa del Sol",
};

export default function Footer() {
  const [f, setF] = useState(DEFAULTS);
  const { t } = useI18n();

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/pages/footer");
        setF({ ...DEFAULTS, ...data });
      } catch (_err) { /* fallback */ }
    })();
  }, []);

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1A1A1A] text-[#F9F6F0] mt-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <p
            className="text-3xl lg:text-4xl font-light leading-tight"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
            data-testid="footer-tagline"
          >
            {f.tagline}
          </p>
          <p className="text-base text-[#A8A39A] mt-6 max-w-md leading-relaxed" data-testid="footer-portal-text">
            {f.portal_text}
          </p>
          <p className="text-base text-[#A8A39A] mt-4 max-w-md leading-relaxed italic" data-testid="footer-disclaimer">
            {f.disclaimer}
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="text-[10px] tracking-[0.3em] uppercase text-[#C5A880] mb-5">
            {t("footer_developments")}
          </p>
          <ul className="space-y-3 text-sm">
            <li>
              <Link to="/developments?category=apartments" className="hover:text-[#C5A880]" data-testid="footer-link-apartments">
                {t("nav_dev_apartments")}
              </Link>
            </li>
            <li>
              <Link to="/developments?category=penthouses" className="hover:text-[#C5A880]" data-testid="footer-link-penthouses">
                {t("nav_dev_penthouses")}
              </Link>
            </li>
            <li>
              <Link to="/developments?category=villas" className="hover:text-[#C5A880]" data-testid="footer-link-villas">
                {t("nav_dev_villas")}
              </Link>
            </li>
            <li>
              <Link to="/developments?category=frontline-golf" className="hover:text-[#C5A880]" data-testid="footer-link-frontline">
                {t("nav_dev_frontline")}
              </Link>
            </li>
            <li>
              <Link to="/developments?category=sea-view" className="hover:text-[#C5A880]" data-testid="footer-link-sea">
                {t("nav_dev_seaview")}
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="text-[10px] tracking-[0.3em] uppercase text-[#C5A880] mb-5">
            {t("footer_explore")}
          </p>
          <ul className="space-y-3 text-sm">
            <li>
              <Link to="/about" className="hover:text-[#C5A880]" data-testid="footer-link-about">
                {t("footer_about")}
              </Link>
            </li>
            <li>
              <Link to="/blog" className="hover:text-[#C5A880]" data-testid="footer-link-blog">
                {t("footer_blog")}
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:text-[#C5A880]" data-testid="footer-link-contact">
                {t("footer_contact")}
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="text-[10px] tracking-[0.3em] uppercase text-[#C5A880] mb-5">
            {t("footer_contact")}
          </p>
          <ul className="space-y-2 text-sm text-[#D7D2C6]">
            <li>
              <a
                href="https://enovaestates.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#F9F6F0] hover:text-[#C5A880] underline underline-offset-4 decoration-[#C5A880]/40 hover:decoration-[#C5A880] transition-colors"
                data-testid="footer-contact-name"
              >
                {f.contact_name}
              </a>
            </li>
            <li data-testid="footer-contact-line1">{f.contact_address_line_1}</li>
            <li data-testid="footer-contact-line2">{f.contact_address_line_2}</li>
            <li className="pt-2">
              <a href={`mailto:${f.contact_email}`} className="text-[#F9F6F0] hover:text-[#C5A880]" data-testid="footer-contact-email">
                {f.contact_email}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#333333]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-6 flex flex-col md:flex-row justify-between gap-4 text-[10px] tracking-[0.2em] uppercase text-[#73706B]">
          <p data-testid="footer-copyright">{f.copyright}</p>
          <p data-testid="footer-tagline-secondary">{f.tagline_secondary}</p>
        </div>
      </div>
    </footer>
  );
}
